import { AppContext } from "./app-context";

export type { IAppContext } from "./app-context";

export const context = new AppContext();

export const getAppVersion: () => string = () => process.env.REACT_APP_VERSION || "unknown version";
